import contractsApiInstance from "@/contractsApi";
// 2026-08-29: 목표 설정 CRUD(/goals*)는 contracts-api 로 이관됨. 호출 화면(계약·이벤트·매출기록·구독관리)이
// 넘겨주는 $apiInstance(inapi) 대신 contracts-api 인스턴스를 쓴다. 경로·본문·응답 동일.
import {dateUtils, logging} from "@/utils/utils";

export default function goalApis($apiInstance, $store) {
    return {
        getGoals: async (params, success, fail) => {
            return contractsApiInstance.post(`/goals/list`, params)
                .then((response) => {
                    logging().exceptProd('goals ==>', response.data)
                    success(response);
                }, (error) => {
                    fail(error);
                });
        },
        createGoals: async (params, success, fail) => {
            $store.commit('setIsLoading', true);
            return contractsApiInstance.post(`/goals`, params)
                .then((response) => {
                    logging().exceptProd('goals ==>', response.data)
                    success(response);
                }, (error) => {
                    fail(error);
                }).finally(() => $store.commit('setIsLoading', false));
        },
        updateGoals: async (params, success, fail) => {
            $store.commit('setIsLoading', true);
            return contractsApiInstance.put(`/goals/${params.year}`, params)
                .then((response) => {
                    logging().exceptProd('goals ==>', response.data)
                    success(response);
                }, (error) => {
                    fail(error);
                }).finally(() => $store.commit('setIsLoading', false));
        }
    }
}